import Parse from '@/parse'
const EntryClosed = Parse.Object.extend('EntryClosed')
const EventClosed = Parse.Object.extend('EventClosed')

export default {
  retrieve ({ commit }, id) {
    var query = new Parse.Query(EntryClosed)
    query.equalTo('event', new EventClosed({ id: id }))
    query.include('allowed')
    query.find().then((results) => {
      commit('setEntries', results)
    }).catch((error) => {
      console.log(error)
    })
  }
}
